import { useRef } from 'react';
import { DatePickerStateOptions, useDatePickerState } from 'react-stately';
import { DateValue, useDatePicker } from '@react-aria/datepicker';
import { CalendarIcon } from 'assets/icons';
import classNames from 'classnames';
import { Calendar, CalendarPopover, DateField, Dialog, FieldButton } from 'modules/datepicker';

import styles from './DatePicker.module.scss';

export type DatePickerProps = {
    popoverId?: string;
    error?: boolean;
    placeholder?: string;
    variant?: 'default' | 'table-inline';
} & DatePickerStateOptions<DateValue>;

export const DatePicker = ({ popoverId, error, placeholder, variant = 'default', ...props }: DatePickerProps) => {
    const ref = useRef<HTMLDivElement>(null);
    const state = useDatePickerState(props);
    const { isOpen } = state;
    const { groupProps, fieldProps, dialogProps, buttonProps, calendarProps } = useDatePicker(props, state, ref);

    return (
        <div
            ref={ref}
            {...groupProps}
            className={classNames(styles['date-picker'], {
                [styles['date-picker-error']]: error,
                [styles['date-picker-open']]: isOpen,
                [styles['date-picker-table-inline']]: variant === 'table-inline',
            })}
        >
            <DateField id={popoverId} placeholder={placeholder} variant={variant} {...fieldProps} />
            <FieldButton
                {...buttonProps}
                className={classNames({
                    [styles['date-picker-button-inline']]: variant === 'table-inline',
                })}
            >
                <CalendarIcon />
            </FieldButton>
            {isOpen && (
                <CalendarPopover triggerRef={ref} state={state}>
                    <Dialog {...dialogProps}>
                        <Calendar {...calendarProps} />
                    </Dialog>
                </CalendarPopover>
            )}
        </div>
    );
};
